// Gender Switch
const collectionListSwitchGender = document.querySelectorAll('.collection-list__switch--gender');
const collectionListSlider = document.querySelector('.collection-list__switch--slider');

collectionListSwitchGender.forEach(el => {
  el.addEventListener('click', function() {

    if (!el.classList.contains('active')) {
      const getGender = this.getAttribute('data-gender');
      const mensCollection = document.querySelector('.collection-list__mens');
      const womensCollection = document.querySelector('.collection-list__womens');
      
      // 1- Remove Active Class
      collectionListSwitchGender.forEach(btn => btn.classList.remove('active'));

      // 2- Add Active Class
      this.classList.add('active');

      // 3- Update Slider & Collection
      if (getGender == 'men') {
        // Update Slider
        collectionListSlider.classList.remove('active-women');
        collectionListSlider.classList.add('active-men');

        // Update Collection
        mensCollection.classList.add('active');
        womensCollection.classList.remove('active');

      } else if (getGender == 'women') {
        // Update Slider
        collectionListSlider.classList.remove('active-men');
        collectionListSlider.classList.add('active-women');

        // Update Collection
        womensCollection.classList.add('active');
        mensCollection.classList.remove('active')
      } 
    }
  })
})

// Slider
// Prevent click event when dragging
var drag = false;

// Allow more than one slider at the same time
document.querySelectorAll('.collection-list__slider').forEach(slider => { 
  new KeenSlider(slider, {
    dragChecked() {
      drag = true;
    },
    dragEnded() {
      setTimeout(() => (drag = false), 0);
    },
    created() {
      document.querySelectorAll('.collection-list__slider').forEach(slider => {
        slider.addEventListener("click", (e) => {
          if (drag) {
            e.stopPropagation();
            e.preventDefault();
          }
        })
      });
    },
    breakpoints: {
      '(max-width: 749px)': {
        slides: {
          perView: 2.5,
          spacing: 16
        }
      },
      '(min-width: 750px)': {
        slides: {
          perView: 3.5,
          spacing: 20
        }
      },
      '(min-width: 990px)': {
        disabled: true,
      },
    },
  }, [navigation])
})